import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageAdminCoursesNewComponent } from './page.admin.courses.new/page.admin.courses.new.component';
import { PageChatComponent } from './page.chat/page.chat.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';

const INDEX_PAGE = "/";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: any[] = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "admin/courses/new",
                component: PageAdminCoursesNewComponent,
                "app_id": "page.admin.courses.new"
            },
            {
                "path": "chat",
                component: PageChatComponent,
                "app_id": "page.chat"
            },
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            },
            {
                "path": "admin/:section?",
                component: PageAdminComponent,
                "app_id": "page.admin"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            }
        ]
    }
];

let normalizeMainRoutes = () => {
    for (let i = 0; i < app_routes.length; i++) {
        let layout: any = app_routes[i];
        let layout_childs: any[] = layout.children || [];
        let dashboard = layout_childs.find((child: any) => child.app_id === "page.dashboard");
        let access = layout_childs.find((child: any) => child.app_id === "page.access");

        if (access) {
            access.path = "";
            let hasAccessAlias = layout_childs.some((child: any) => child !== access && child.path === "access");
            if (!hasAccessAlias) {
                layout_childs.push({ ...access, path: "access" });
            }
        }

        if (dashboard) {
            dashboard.path = access ? "dashboard" : "";
            let hasDashboardAlias = layout_childs.some((child: any) => child !== dashboard && child.path === "dashboard");
            if (!hasDashboardAlias && !access) {
                layout_childs.push({ ...dashboard, path: "dashboard" });
            }
        }
    }
};

normalizeMainRoutes();

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

declare global {
    interface Window {
        WizRoute: RouteInfo;
    }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams: any = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let layoutMatcher = (layout_childs: any[]) => {
    return (url: any) => {
        for (let i = 0; i < layout_childs.length; i++) {
            let child = layout_childs[i];
            if (patternMatcher(child.path, url)) {
                return { consumed: [], posParams: {} };
            }
        }
        return null;
    };
};

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout: any = app_routes[i];
            let layout_childs: any[] = layout.children || [];
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout: any = app_routes[i];
    let layout_component = layout.component;
    let layout_childs: any[] = layout.children || [];

    let router: any = {
        matcher: layoutMatcher(layout_childs),
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
